<template>
    <iframe width="100%" :height="dynaHeight" :src="'/processCenter/taskAlreadyMatter.html?saas_system=tbporderp&saas_token='+token" frameborder="0"></iframe>
</template>

<script>
export default {
    data(){
        return {
            dynaHeight: document.documentElement.clientHeight - 105,
            token:document.cookie.split(';').filter(item=>item.indexOf('_TOKEN_KEY_')>-1)[0].replace('_TOKEN_KEY_=','').trim()
        }
    }
}
</script>